import { render, staticRenderFns } from "./FormularioAtividade.vue?vue&type=template&id=11c0bc4c&scoped=true"
import script from "./FormularioAtividade.vue?vue&type=script&lang=js"
export * from "./FormularioAtividade.vue?vue&type=script&lang=js"
import style0 from "./FormularioAtividade.vue?vue&type=style&index=0&id=11c0bc4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c0bc4c",
  null
  
)

export default component.exports